export default __webpack_public_path__ + "static/media/NotoSans-Light.d3283d22.woff2";